


















































import { defineComponent, ref } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { Select2 } from '@/components/form'
import { DatePicker } from '@/components/general'

// const
import { APP_URL_API } from '@/constants'

// utils
import { dateLibs } from '@/utils'

export default defineComponent({
  name: 'ReportAfp',
  components: {
    PageHeader,
    DatePicker,
    Select2
  },
  setup () {
    const URL_PDF = 'reports/afp'
    const title = ref('Reporte de Asistencia')
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Reporte AFP',
        active: true
      }
    ]
    const year = ref(null)
    const month = ref(null)

    const printReport = () => {
      window.open(`${APP_URL_API}${URL_PDF}?year=${year.value}&month=${month.value}`, '_blank')
    }

    const addDaysToDate = (date: string) => {
      return dateLibs.addDaysToDate(date, 29)
    }

    return {
      title,
      breadcrumbs,
      years,
      months,
      year,
      month,
      printReport,
      addDaysToDate
    }
  }
})
